import { TextButton } from "@/src/components/links/components/TextButton";
import TooltipButtonPanel from "../../../../../Tooltip/components/TooltipButtonPanel";
import { Label4 } from "@/src/components/typography/components/Label";

type Props = React.PropsWithChildren<{
  onClick: () => void;
}>;

const PROPERTIES_TOOLTIP_HEADER = "Properties (% have this trait)";
const PROPERTIES_TOOLTIP_COPY =
  "The characteristics that make this Nike Virtual Creation what it is. Calculated as (# of revealed Nike Virtual Creations with this property in the collection / total # of revealed Nike Virtual Creations in the collection) 100.";

const TokenPropertiesView: React.FC<Props> = ({ onClick, children }) => {
  return (
    <div className="mb-8 flex-[4] dark">
      <div className="flex items-baseline justify-between">
        <div className="flex gap-1 mb-5 items-center">
          <Label4>Properties</Label4>
          <TooltipButtonPanel
            label={PROPERTIES_TOOLTIP_HEADER}
            tooltipCopy={PROPERTIES_TOOLTIP_COPY}
          />
        </div>

        <TextButton className="md:hidden" onClick={onClick}>
          View All
        </TextButton>
      </div>
      {children}
    </div>
  );
};

export default TokenPropertiesView;
